export const FLOW_NAME = "time-series";
export type FLOW_TYPE = "time-series";

export const INPUT_DATA = "input-data";

export const TIMESTAMP_VAR = "time-column";

export const TS_FILE = "time-series-transformed-data";

export const MAX_LABELS_TO_RENDER = 500;
